import { VinylRecordCondition, VinylRecordPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  record_artist: {
    friendly: 'Artist',
    validations: {
      maxLength: 255,
    },
  },

  record_genre: {
    friendly: 'Genre',
    validations: {
      maxLength: 255,
    },
  },

  record_country_produced: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  record_year_released: {
    friendly: 'Year Released',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  record_label: {
    friendly: 'Label',
    validations: {
      maxLength: 255,
    },
  },

  record_musicians: {
    friendly: 'Musicians',
    validations: {
      maxLength: 255,
    },
    typeHint: typeHints.TextArea,
  },

  record_producers: {
    friendly: 'Producers',
    validations: {
      maxLength: 255,
    },
  },

  record_track_list: {
    friendly: 'Track List',
    validations: {
      maxLength: 255,
    },
    typeHint: typeHints.TextArea,
  },

  record_upc: {
    friendly: 'Upc',
    validations: {
      maxLength: 255,
    },
  },

  record_rating: {
    friendly: 'Rating',
    validations: {
      maxLength: 255,
    },
  },

  record_msrp: {
    friendly: 'MSRP',
    validations: {
      maxLength: 32000,
    },
  },

  record_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: VinylRecordCondition,
    },
  },

  record_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: VinylRecordPurchaseCondition,
    },
  },

};

export default attributes;

export const VinylRecordDefaultSplitAttribute = 'record_artist';

export const VinylRecordItemSearchAttributes = [];

export const VinylRecordOverviewAttributes = ['title', 'record_artist', 'record_year_released', 'record_condition', 'rarity', 'market_value',
  'inventory_no', 'tags'];

export const VinylRecordSpecificationAttributes = ['record_year_released', 'record_label', 'record_msrp', 'record_upc', 'record_musicians',
  'record_producers', 'record_rating', 'record_track_list'];

export const VinylRecordPurchaseAttributes = ['purchase_date', 'purchase_price', 'record_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const VinylRecordDetailAttributes = [];

export const VinylRecordRequiredAttributes = [];

export const VinylRecordDisplayAttributes = ['record_artist', 'record_year_released', 'tags'];

export const VinylRecordSliderGalleryAttributes = {
  titleKey: 'record_artist',
  subtitleKey: 'record_genre',
};



// WEBPACK FOOTER //
// ./src/config/vinylRecordDataAttributes.js